import React, { useState, useEffect } from 'react';

import HeaderNavigation from './header-navigation/HeaderNavigation';
import Footer from './Footer/Footer';
import PropTypes from 'prop-types';

const Layout = ({ children, headerContainer, HeaderComponent, headerTextColor, logosColor }) => {
  const [header, setHeader] = useState('header');

  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent);
    return () => window.removeEventListener('scroll', listenScrollEvent);
  }, []);

  const listenScrollEvent = () => {
    if (window.scrollY < 73) {
      return setHeader('header');
    } else if (window.scrollY > 350) {
      return setHeader('header2');
    }
  };
  return (
    <>
      <header className={headerContainer}>
        <nav className={`${header == 'header' ? 'header' : 'header2'} `}>
          <HeaderNavigation
            logosColor={header == 'header' && logosColor}
            textColor={header == 'header2' ? 'text-gray-700' : headerTextColor}
          />
        </nav>
        {HeaderComponent}
      </header>
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;

Layout.defaultProps = {
  headerTextColor: 'text-white'
};
